import React, { useState, useEffect, useRef } from 'react';
import { CommentsAPI } from '../../api';
import CommentList from './CommentList';

const ShowComments = ({ showId }) => {
  const [commentCount, setCommentCount] = useState(0);
  const isLoadingComments = useRef(false);
  
  // Get comment count
  useEffect(() => {
    const fetchCommentCount = async () => {
      // Prevent duplicate API calls
      if (isLoadingComments.current) return;
      
      try {
        isLoadingComments.current = true;
        const response = await CommentsAPI.getContentComments('show', showId, {
          limit: 1,
          skip: 0
        });
        
        if (response.data && response.data.data) {
          setCommentCount(response.data.data.total || 0);
        }
      } catch (err) {
        console.error('Error fetching comment count:', err);
      } finally {
        isLoadingComments.current = false;
      }
    };
    
    if (showId) {
      fetchCommentCount();
    }
    
    // Clean up function
    return () => {
      isLoadingComments.current = false;
    };
  }, [showId]);
  
  return <CommentList contentType="show" contentId={showId} />;
};

export default ShowComments; 